module.exports = __webpack_public_path__ + "img/6_94.ede0ad24.png";